module.exports = __webpack_public_path__ + "static/media/icon1.50c74460.jpg";